import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { Address } from '@df/session/api/address-book/address';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';

@Component({
    selector: 'address',
    templateUrl: './address.html',
    standalone: true,
    imports: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressComponent {
    protected _model: Address;

    /**
     * Model setter
     */
    @Input()
    set model(model: Address) {
        this._model = model;
        this._ref.detectChanges();
    }

    /**
     * Model getter
     */
    get model(): Address {
        return this._model;
    }

    @Input() custom: any;

    constructor(protected _ref: ChangeDetectorRef) {}
}
